/*
 * Copyright (c) 2021-2024 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
 * LicenseRef-NvidiaProprietary
 *
 * NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
 * property and proprietary rights in and to this material, related
 * documentation and any modifications thereto. Any use, reproduction,
 * disclosure or distribution of this material and related documentation
 * without an express license agreement from NVIDIA CORPORATION or
 * its affiliates is strictly prohibited
 */

import Vue from 'vue';

import Clipboard from 'v-clipboard';
import CumulusVue from '@cumulus/cumulus-vue';
import VueProgressBar from 'vue-progressbar';
import VModal from 'vue-js-modal';
import VTooltip from 'v-tooltip';

import App from './App.vue';
import router from './router';
import * as env from './util/env';

import '@cumulus/air-ui-kit/air.scss';
import '@cumulus/cumulus-vue/lib/cumulus-vue.css';

Vue.config.productionTip = false;

Vue.use(Clipboard);
Vue.use(CumulusVue);
Vue.use(VueProgressBar, {
    color: '#76b900', // nvidia-green
    position: 'relative',
    thickness: '10px',
});
Vue.use(VModal, {
    dynamicDefaults: {
        height: 'auto',
    },
});
Vue.use(VTooltip);

const init = async () => {
    await env.loadEnvVars();
    new Vue({
        router,
        render: h => h(App),
    }).$mount('#app');
};
init();
